import { useEffect, useState } from "react";
import styled from "styled-components";
import { PdfContainer } from "./../../components/PdfContainer";

export const DownloadFiles = ({ additionalInfos, fittingInfos }) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (fittingInfos.length === 0 && additionalInfos.length === 0) {
      setLoading(false);
    } else if (fittingInfos.length > 0 || additionalInfos.length > 0) {
      setLoading(false);
    }
  }, [fittingInfos, additionalInfos]);

  if (loading) {
    return <InstructionContainer>Loading data ...</InstructionContainer>;
  }

  return (
    <DownloadContainer>
      <InstructionContainer>
        <h4>Fitting Instructions</h4>
        {fittingInfos.length > 0 ? (
          fittingInfos.map((info, index) => (
            <PdfContainer
              key={index}
              file={info}
              urlKey="contentUrl"
              textKey="fileName"
            />
          ))
        ) : (
          <p>No Fitting Information Found</p>
        )}
      </InstructionContainer>
      <InstructionContainer>
        <h4>Additional Information</h4>
        {additionalInfos.length > 0 ? (
          additionalInfos.map((info, index) => (
            <PdfContainer
              key={index}
              file={info}
              urlKey="contentUrl"
              textKey="fileName"
            />
          ))
        ) : (
          <p>No Additional Information Found</p>
        )}
      </InstructionContainer>
    </DownloadContainer>
  );
};

const DownloadContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  width: 100%;
  gap: 40px;
`;

const InstructionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
